<template>
    <div class="left-pannel" id="menu" style="overflow-y: scroll;">

        <div class="top-pannel">
            <router-link :to="{name: 'profil'}">
                <div class="img-profil" :style="'background-image: url('+photoProfil+')'"></div>
            </router-link>
            <h1 class="user">
                <router-link :to="{name: 'profil'}">
                    <strong>{{ last_name }}</strong> <br>
                    {{ first_name }}
                </router-link><br><br>
                <router-link :to="{name: 'profil'}">
                    <span class="idOperator">id client : {{ idOperator }}-{{ idUser }}</span>
                </router-link>
            </h1>
            <i class="icon-error" id="close-pannel" @click="closeMenu"></i>
        </div>

        <div class="mid-pannel">
            <hr>
            <ul>
                <router-link :to="{name : 'home'}">
                    <i class="icon-home"></i>
                    <span>
                    <strong>ACCUEIL</strong>
                </span>
                </router-link>
                <hr>

                <span v-if="type === 'technicien'">

                    <router-link :to="{name : 'liste-fibsdd'}">
                        <i class="icon-tools"></i>
                        <span>
                            <strong>INTERVENTIONS</strong><br>
                        </span>
                    </router-link>
                    <hr>

                    <router-link :to="{ name : 'ctrl-multi'}">
                        <i class="icon-tools"></i>
                        <span>
                            <strong>CONTROLES </strong><br>
                            D'étancheite multiples
                        </span>
                    </router-link>
                    <hr>
                    <router-link :to="{name : 'contrat-assemblage' }">
                        <i class="icon-contract"></i>
                        <span>
                            <strong>CONTRAT</strong><br>
                            D'ASSEMBLAGE
                        </span>
                    </router-link>
                    <hr>

                </span>

                <router-link :to="{name : 'liste-detenteurs' }">
                    <i class="icon-factory"></i>
                    <span>
                    <strong>DÉTENTEURS</strong><br>
                    & INSTALLATIONS
                </span>
                </router-link>
                <hr>
                <router-link :to="{name : 'liste-bouteilles'}">
                    <i class="icon-gas"></i>
                    <span>
                   <strong>BOUTEILLES</strong>
                </span>
                </router-link>
                <hr>

                <router-link :to="{name: 'restitution-bouteilles'}">
                    <i class="icon-gas"></i>
                    <span>
                    <strong>RESTITUTION</strong><br>
                    BOUTEILLES EN VOLUME
                </span>
                </router-link>
                <hr>

                <span v-if="type === 'technicien'">

                    <router-link :to="{name : 'liste-outils'}">
                        <i class="icon-tool"></i>
                        <span>
                        <strong>OUTILLAGE</strong>
                    </span>
                    </router-link>
                    <hr>

                </span>

                <span id="spanSupportMenu" class="hide">
                    <a href="#" id="btnSupportMenu" @click.prevent="openSupport">
                        <i class="icon-info">
                        </i>

                        <div v-if="badgeCount > 0" class="indicator_menu">
                            <div class="noti_count_menu" role="status">{{ badgeCount }}</div>
                        </div>
                        <span>
                            <strong>DEMANDE SUPPORT</strong><br>
                        </span>
                    </a>
                    <hr>
                </span>

            </ul>

        </div>

        <div class="buttons">
            <a href="fi360://scan?success=tryGoTo" class="btn btn-full">Scan Otag Bouteille</a>
            <a href="fi360://scan?success=tryGoToInstall" class="btn btn-full">Scan Otag Install</a>
        </div>

        <dialog ref="supportDialog" style="width: 100%; height: 100%; border: none;">
            <i class="icon-error" id="close-pannel-support" @click="$refs.supportDialog.close()"></i>
            <object id="supportObject" type="text/html" style="width: 100%; height: 100%;"></object>
        </dialog>

    </div>
</template>

<script>
    import User from '../../js/models/User'
    import Hammer from 'hammerjs'

    export default {

        data() {
            return {
                photoProfil: null,
                last_name: null,
                first_name: null,
                type: null,
                idOperator: null,
                idUser : null,
                supportUrl: null,
            }
        },

        methods: {
            closeMenu: function () {
                document.getElementById('menu').classList.remove('open')
            },
            lock: function (e) {
                e.preventDefault();
                swal('Indisponible', 'Cette fonctionnalité sera disponible prochainement', 'error')
            },
            openSupport: function () {
                if (!this.supportUrl) return;
                document.getElementById('supportObject').setAttribute('data', this.supportUrl);
                this.$refs.supportDialog.showModal();
            }
        },
        computed: {
            badgeCount() {
                return this.$root.badgeCount;
            }
        },

        mounted() {

            User.getUserData(data => {
                if (!data || !data.operator) return;
                if (data.photo64 !== '') {
                    this.photoProfil = data.photo64
                } else {
                    this.photoProfil = '../../img/default.png'
                }
                this.last_name = data.last_name;
                this.first_name = data.first_name;
                this.type = data.type;
                this.idUser = ('0000' + data.uid).slice(-4);
                this.idOperator = ('0000' + data.operator.id).slice(-4);
            })

            let pannel = this.$el;
            this.hammerMenu = new Hammer(pannel);
            this.hammerMenu.on('swipeleft',function(){
                pannel.classList.remove('open')
            });


            localforage.getItem('profil').then(user => {
                user = JSON.parse(user);
                if (!user || !user.operator) return;
                let idUser = user.id;
                let tokenOperator = user.operator.token;

                if(tokenOperator != null) {
                    this.supportUrl = "https://support.fi360.fr/public/list?token=" + encodeURIComponent(tokenOperator) + "&user=" + idUser;
                    document.getElementById('spanSupportMenu').classList.remove('hide');
                }

            });


        },

        beforeDestroy() {
            if (this.hammerMenu) {
                this.hammerMenu.destroy();
            }
        }

    }

</script>

<style>

    #menu {
        position: fixed;
        height: 100%;
        width: 85%;
        left: -85%;
        top: 0;
        background-color: #393c51;
        transition: 0.3s ease all;
        z-index: 999;
        color: #fbfafa;
    }

    #menu::-webkit-scrollbar {
        display: none;
    }

    #menu.open {
        left: 0;
        box-shadow: 1px 0 8px 0.5px #656565;
        /* overflow-y: scroll; */
    }

    #menu .top-pannel {
        display: flex;
        height: 100px;
        width: 100%;
        background-color: #1d1e29;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    #menu .top-pannel > a {
        float: left;
        height: 80px;
        width: 80px;
        margin: 10px;
    }

    #menu .top-pannel > a .img-profil {
        border-radius: 50%;
        height: 100%;
        width: 100%;
        background-size: cover;
        background-position: center;
    }

    #menu .top-pannel > h1 {
        float: left;
        margin-left: 10px;
        padding-right: 45px;
        line-height: 1;
        text-transform: uppercase;
    }

    #menu .top-pannel > h1 a {
        color: #fff;
    }

    #menu .top-pannel > i {
        position: absolute;
        top: 30px;
        right: 10px;
        font-size: 3.3rem;
    }

    #menu .mid-pannel {
        width: 100%;
    }

    #menu .mid-pannel hr {
        display: block;
        width: 100%;
        height: 1px;
        background-color: #fbfafa;
        outline: none;
        border: none;
        margin: auto;
    }

    #menu .mid-pannel a {
        height: 60px;
        margin: 0;
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        line-height: 1.1;
        font-weight: 400;
        text-transform: uppercase;
        text-decoration: none;
        color: #fbfafa;
        font-size: 1.2rem;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        transition: all 250ms ease;
    }

    #menu .mid-pannel a strong {
        font-weight: 700;
        font-size: 1.8rem;
    }

    #menu .mid-pannel a i {
        color: #fbfafa;
        font-size: 3.3rem;
        margin: 0 10px;
    }

    #menu .mid-pannel a:after {
        content: '\e909';
        font-family: 'fi360' !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        font-size: 3.3rem;
        position: absolute;
        right: 10px;
        top: 14px;
    }

    #menu .mid-pannel a:hover {
        background-color: #1d1e29;
    }

    #menu .mid-pannel a.router-link-active {
        background-color: #1d1e29;
    }

    .notif {
        background-color: #c31616;
        height: 22px;
        width: 22px;
        border-radius: 50%;
        padding: 5px 10px;
    }

    #menu .buttons {
        margin-top: 10px;
        display: flex;
        justify-content: space-around;
    }

    #menu .buttons .btn {
        padding: 5px 10px;
        font-weight: 600;
        background-color: #1d1e29;
    }

    #swal2-content .question-info {
        display: inline-block;
        max-width: 100%;
        margin: 10px auto 0;
        background-color: #393c51;
        font-size: 16px;
        padding: 6px 14px;
        border-radius: 15px;
        color: white;
        cursor: pointer;
    }

    #swal2-content .question-info .title {
        display: block;
        margin-top: 8px;
        font-size: 14px;
        line-height: 1.4;
        text-align: left;
        white-space: pre-line;
    }

    ::backdrop {
        background: black;
        opacity: 0.75;
    }

    #close-pannel-support {
        color: #000;
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 3.3rem;
    }

    .indicator_menu {
        position: absolute;
        top: 5px; /* Adjusted for better vertical positioning */
        left: 35px; /* Adjusted for better horizontal positioning */
        width: 20px;
        height: 20px;
        background-color: red;
        border: 3px solid white;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .noti_count_menu {
        font-family: 'Montserrat', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
        color: aliceblue;
        font-weight: 700;
        font-size: 12px;
    }

</style>



// WEBPACK FOOTER //
// Menu.vue?dba09ec0